import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import lists from './modules/employee/lists';
import adminLists from './modules/admin/lists';
import debts from './modules/employee/debts';
import adminDebtors from './modules/admin/debtors';
import adminDebts from './modules/admin/debts';
import adminUsers from './modules/admin/users';
import addresses from './modules/employee/addresses';
import phones from './modules/employee/phones';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    lists,
    debts,
    phones,
    addresses,
    adminLists,
    adminDebtors,
    adminDebts,
    adminUsers,
  },
});
